
import styled from "styled-components";
import BackBannerNice from "assets/images/login_back.jpg";

export const ContentWrapper = styled.div`
    position:relative;
  `;


export const TopStrip = styled.div`
    background: #cda55614;
    height: 18vh;
    width: 100%;
    margin-bottom: 15px;
    background-image: url(${BackBannerNice});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: top;
    background-attachment: fixed;
    `; 